
import EmptyAdsImage from '@/media/MultiAgentsHome/emptyAdsImage.png';
import React from 'react';
import * as Styles from './AccountWithoutAds.styles';
import useLocale from '@/hooks/useLocale';
import {
  Button, IconMegaphone, SelectField,
} from 'gatorcomponents';

const AccountWithoutAds = ({
  handleOpenGator,
  options,
  SelectedAccountLabel,
}) => {
  const { marketing: marketingLocale } = useLocale();
  const { multiAgentScreens: multiAgentScreensLocale } = marketingLocale;
  const { withoutAds: withoutAdsLocale } = multiAgentScreensLocale;

  const handleClick = () => {
    handleOpenGator && handleOpenGator({
      message: withoutAdsLocale.ctaMessage,
    });
  };

  return (
    <Styles.Container>
      <Styles.StyledContainer>
        <Styles.TitleRow>
          <Styles.Title>
            {withoutAdsLocale.firstTitle}
          </Styles.Title>


          <Styles.SelectWrapper>
            <SelectField
              value={SelectedAccountLabel}
              options={options}
            />
          </Styles.SelectWrapper>
        </Styles.TitleRow>

        <Styles.Content>
          <Styles.Image src={EmptyAdsImage} />

          <Styles.SecondTitle>
            {withoutAdsLocale.secondTitle}
          </Styles.SecondTitle>

          <Styles.Description>
            {withoutAdsLocale.description}
          </Styles.Description>

          <Styles.ButtonWrapper>
            <Button
              iconLeft={<IconMegaphone color="highPure" />}
              label={withoutAdsLocale.cta}
              size="large"
              notFillSVG
              onClick={handleClick}
            />
          </Styles.ButtonWrapper>
        </Styles.Content>
      </Styles.StyledContainer>
    </Styles.Container>
  );
};

export default AccountWithoutAds;
